module.exports = __webpack_public_path__ + "static/media/close-dark.21e2cae1.svg";